RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    apps.Favorites = window.createMarionetteApp();
});
